import { render, staticRenderFns } from "./MaterialGroup.vue?vue&type=template&id=78b274ed&scoped=true"
import script from "./MaterialGroup.vue?vue&type=script&lang=js"
export * from "./MaterialGroup.vue?vue&type=script&lang=js"
import style0 from "./MaterialGroup.vue?vue&type=style&index=0&id=78b274ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b274ed",
  null
  
)

export default component.exports